<app-chart
  *ngIf="chartConfig && isVisible"
  [configuration]="chartConfig"
  [data]="data"
  [isDarkTheme]="isDarkTheme$ | async"></app-chart>
